<div class="clock-loader"></div>